module.exports = __webpack_public_path__ + "static/media/legal_everything.b71f399d.png";